import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipWrapper } from "@/components/ui/TooltipWrapper";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProcurementProvider } from "@/context/ProcurementContext";
import { AlertProvider } from "@/context/AlertContext";
// import { StateDebugPanel } from "@/components/debug/StateDebugPanel";
import ErrorBoundary from "@/components/ErrorBoundary";
import "@/utils/dataPersistenceTest"; // Import for auto-testing in development
import Index from "./pages/Index";
import SKUManagement from "./pages/SKUManagement";
import VendorManagement from "./pages/VendorManagement";
import PurchaseOrders from "./pages/PurchaseOrders";
import POApprovalPage from "./pages/POApprovalPage";
import QualityManagement from "./pages/QualityManagement";
import InvoiceManagement from "./pages/InvoiceManagement";
import VendorInvoiceManagement from "./pages/VendorInvoiceManagement";
import POManagement from "./pages/POManagement";
import SecurityVerification from "./pages/SecurityVerification";
import FloorManagerDispatch from "./pages/FloorManagerDispatch";
import HandoverLog from "./pages/HandoverLog";
import QuantityTesting from "./pages/QuantityTesting";
import UserManagement from "./pages/UserManagement";
import Settings from "./pages/Settings";
import DebitNotes from "./pages/DebitNotes";
import ManagerSection from "./pages/ManagerSection";
import NotFound from "./pages/NotFound";

// Create query client outside component to prevent recreations
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  console.log('App component rendering');
  
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipWrapper>
          <AlertProvider>
            <ProcurementProvider>
              <Toaster />
              <Sonner />
            <BrowserRouter
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/skus" element={<SKUManagement />} />
                  <Route path="/vendors" element={<VendorManagement />} />
                  <Route path="/purchase-orders" element={<PurchaseOrders />} />
                  <Route path="/purchase-orders/approve/:poId" element={<POApprovalPage />} />
                  <Route path="/quality" element={<QualityManagement />} />
                  <Route path="/invoices" element={<InvoiceManagement />} />
                  <Route path="/vendor-invoices" element={<VendorInvoiceManagement />} />
                  <Route path="/po-management" element={<POManagement />} />
                  <Route path="/security-verification" element={<SecurityVerification />} />
                  <Route path="/floor-manager-dispatch" element={<FloorManagerDispatch />} />
                  <Route path="/handover-log" element={<HandoverLog />} />
                  <Route path="/quantity-testing" element={<QuantityTesting />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/debit-notes" element={<DebitNotes />} />
                  <Route path="/manager-section" element={<ManagerSection />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ErrorBoundary>
            </BrowserRouter>
            {/* Debug Panel - temporarily disabled to fix context error */}
            {/* {import.meta.env.DEV && <StateDebugPanel />} */}
            </ProcurementProvider>
          </AlertProvider>
        </TooltipWrapper>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;